import React, { useEffect, useState } from "react";
import "./blog.scss";
import { getBlogBySlug } from "../../utils/services";
import { formatBlogsDate } from "../../utils/helpers";
import Footer from "../landing/footer/Footer";
const BlogDetail = () => {
  const [blogData, setBlogData] = useState(null);
  const searchParams = new URLSearchParams(window.location.search);
  const slug = searchParams.get("slug");

  useEffect(() => {
    (async () => {
      try {
        window.scrollTo(0, 0);
        const blogDetailsData = await getBlogBySlug(slug);
        setBlogData(blogDetailsData);
      } catch (error) {
        console.error("Error fetching blog detail:", error);
      } 
    })();
  }, [slug]);


  return (
    <>
      <section className="main_data_blogs">
        <div className="custom-container">
          <div className="blogs_Data_inner">
            <span>{formatBlogsDate(blogData?.date)}</span>
            <h2>{blogData?.title?.rendered}</h2>
            <img
              src={
                blogData?.jetpack_featured_media_url ||
                "/assets/blog/blogmainimg.png"
              }
              className="imggginner img-fluid"
              alt={blogData?.title?.rendered}
            />
            <div className="share_side">
              <div className="lefttside">
                <p>Share:</p>
                <div className="icccons">
                  <a href="#" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M9.12244 1.125H10.7764L7.16294 5.255L11.4139 10.875H8.08544L5.47844 7.4665L2.49544 10.875H0.840441L4.70544 6.4575L0.627441 1.125H4.04044L6.39694 4.2405L9.12244 1.125ZM8.54194 9.885H9.45844L3.54244 2.063H2.55894L8.54194 9.885Z"
                        fill="#DAD9D9"
                      />
                    </svg>
                  </a>
                  <a href="#" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M6.92934 12V6.52664H8.76578L9.0413 4.39294H6.92934V3.03088C6.92934 2.41332 7.10013 1.99246 7.98671 1.99246L9.11564 1.99199V0.083538C8.92041 0.0581672 8.25025 0 7.47025 0C5.84149 0 4.72641 0.994179 4.72641 2.81956V4.39294H2.8844V6.52664H4.72641V12H6.92934Z"
                        fill="#DAD9D9"
                      />
                    </svg>
                  </a>
                  <a href="#" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M8.28725 4.70772C8.59394 4.3919 8.89841 3.655 7.62053 4.54981C6.42682 5.39584 5.225 6.22966 4.01523 7.05119C3.83102 7.13695 3.63186 7.18352 3.42974 7.18804C3.22761 7.19256 3.02669 7.15497 2.83903 7.0775C2.0723 6.84064 1.17722 6.52482 1.17722 6.52482C1.17722 6.52482 0.566061 6.12948 1.61226 5.70839C1.61226 5.70839 6.0354 3.83922 7.56941 3.1807C8.15724 2.91752 10.1513 2.07534 10.1513 2.07534C10.1513 2.07534 11.0719 1.70631 10.9952 2.6017C10.9697 2.97015 10.7652 4.26089 10.5608 5.65576C10.2535 7.63018 9.92127 9.78941 9.92127 9.78941C9.92127 9.78941 9.87016 10.3947 9.43567 10.5C8.97058 10.4919 8.52121 10.3253 8.15779 10.0263C8.05556 9.94732 6.24041 8.76243 5.57536 8.18344C5.50769 8.13624 5.45274 8.07221 5.41557 7.99726C5.37845 7.92232 5.36028 7.8389 5.36284 7.7548C5.3654 7.67069 5.38856 7.58865 5.43018 7.51622C5.47179 7.44384 5.53052 7.38342 5.60091 7.34069C6.5131 6.48129 7.40868 5.60346 8.28725 4.70772Z"
                        fill="#DAD9D9"
                      />
                    </svg>
                  </a>
                  <a href="#" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_3619_2083)">
                        <path
                          d="M5.99965 0.47998C2.95597 0.47998 0.47965 2.9563 0.47965 5.99998C0.47965 6.95038 0.72517 7.88494 1.19077 8.70958L0.48853 11.2152C0.46549 11.2975 0.48781 11.3858 0.54733 11.447C0.59317 11.4943 0.65557 11.52 0.71965 11.52C0.73885 11.52 0.75829 11.5176 0.77725 11.513L3.39229 10.8653C4.19077 11.2939 5.09005 11.52 5.99965 11.52C9.04333 11.52 11.5196 9.04366 11.5196 5.99998C11.5196 2.9563 9.04333 0.47998 5.99965 0.47998ZM8.77645 7.94782C8.65837 8.2747 8.09197 8.57302 7.81981 8.6131C7.57549 8.64886 7.26637 8.66422 6.92701 8.55766C6.72133 8.49286 6.45733 8.40694 6.11917 8.2627C4.69765 7.65646 3.76933 6.2431 3.69829 6.14974C3.62749 6.05638 3.11965 5.3911 3.11965 4.70254C3.11965 4.01398 3.48565 3.67534 3.61573 3.53518C3.74581 3.39502 3.89917 3.35998 3.99373 3.35998C4.08829 3.35998 4.18261 3.36118 4.26541 3.36502C4.35253 3.36934 4.46941 3.33214 4.58437 3.60526C4.70245 3.88558 4.98589 4.57414 5.02093 4.64446C5.05645 4.71454 5.07997 4.79638 5.03293 4.88974C4.98589 4.9831 4.96237 5.04142 4.89133 5.12326C4.82029 5.2051 4.74253 5.30566 4.67869 5.36854C4.60765 5.43838 4.53397 5.51398 4.61653 5.65414C4.69909 5.7943 4.98349 6.25246 5.40493 6.6235C5.94613 7.10014 6.40285 7.24798 6.54445 7.31806C6.68605 7.38814 6.76885 7.37638 6.85141 7.28302C6.93397 7.18942 7.20565 6.8743 7.29997 6.73438C7.39429 6.59446 7.48885 6.6175 7.61893 6.6643C7.74901 6.71086 8.44573 7.04926 8.58733 7.11934C8.72893 7.18942 8.82349 7.22446 8.85901 7.28278C8.89453 7.34086 8.89453 7.62118 8.77645 7.94782Z"
                          fill="#DAD9D9"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3619_2083">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <a href="#" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_3619_2086)">
                        <path
                          d="M7.00311 7.35216C6.70456 7.55119 6.35778 7.6564 6.00024 7.6564C5.64273 7.6564 5.29595 7.55119 4.9974 7.35216L0.0801426 4.07388C0.0528613 4.0557 0.0262832 4.03674 0.000244141 4.01724V9.38904C0.000244141 10.0049 0.500049 10.4937 1.10492 10.4937H10.8955C11.5114 10.4937 12.0002 9.99391 12.0002 9.38904V4.01721C11.9741 4.03676 11.9475 4.05577 11.9202 4.07398L7.00311 7.35216Z"
                          fill="#DAD9D9"
                        />
                        <path
                          d="M0.470166 3.48885L5.38742 6.76715C5.57356 6.89125 5.78689 6.95329 6.00022 6.95329C6.21357 6.95329 6.42692 6.89122 6.61306 6.76715L11.5303 3.48885C11.8246 3.2928 12.0002 2.96467 12.0002 2.61053C12.0002 2.0016 11.5048 1.50623 10.8959 1.50623H1.10455C0.495643 1.50625 0.000244141 2.00162 0.000244141 2.61112C0.000244141 2.96467 0.175932 3.2928 0.470166 3.48885Z"
                          fill="#DAD9D9"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3619_2086">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <a href="#" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_3619_2090)">
                        <path
                          d="M7.32211 4.67729C7.17996 4.5343 7.02235 4.40755 6.8522 4.29936C6.40153 4.01077 5.87761 3.85743 5.34247 3.85743C4.5997 3.85604 3.88712 4.15116 3.36282 4.67729L0.819278 7.22282C0.295872 7.74724 0.00168995 8.45776 0.00122128 9.19867C0.000237084 10.7448 1.25279 11.999 2.79892 12C3.54054 12.0025 4.25247 11.7088 4.77658 11.1841L6.8762 9.08448C6.91435 9.04666 6.93565 8.99506 6.93534 8.94135C6.93471 8.83091 6.84466 8.74191 6.73422 8.74254H6.65424C6.21557 8.74409 5.78081 8.65985 5.37448 8.49459C5.29961 8.46378 5.21356 8.48117 5.15652 8.53858L3.64679 10.0503C3.17798 10.5191 2.4179 10.5191 1.94909 10.0503C1.48028 9.5815 1.48028 8.82142 1.94909 8.35261L4.50264 5.80108C4.97107 5.33323 5.72991 5.33323 6.19834 5.80108C6.51404 6.09819 7.00646 6.09819 7.32213 5.80108C7.45795 5.66514 7.5403 5.48485 7.5541 5.29316C7.5687 5.0641 7.48422 4.83977 7.32211 4.67729Z"
                          fill="#DAD9D9"
                        />
                        <path
                          d="M11.1795 0.819995C10.0861 -0.273332 8.31351 -0.273332 7.22018 0.819995L5.12255 2.91561C5.06495 2.97349 5.04834 3.06055 5.08056 3.13558C5.11241 3.21082 5.18683 3.25912 5.26852 3.25755H5.3425C5.78065 3.25675 6.21471 3.34165 6.62027 3.50751C6.69514 3.53833 6.78118 3.52094 6.83822 3.46353L8.34395 1.95979C8.81276 1.49098 9.57284 1.49098 10.0416 1.95979C10.5105 2.4286 10.5105 3.18868 10.0416 3.65749L8.16597 5.53114L8.14997 5.54914L7.4941 6.20103C7.02566 6.66887 6.26682 6.66887 5.79839 6.20103C5.4827 5.90392 4.99027 5.90392 4.6746 6.20103C4.53792 6.338 4.4555 6.51986 4.44264 6.71293C4.42801 6.94199 4.51249 7.16632 4.6746 7.32882C4.90605 7.56126 5.17685 7.75081 5.47445 7.88872C5.51644 7.90871 5.55844 7.92471 5.60043 7.94271C5.64242 7.9607 5.68641 7.97469 5.7284 7.9907C5.77039 8.0067 5.81437 8.02069 5.85637 8.03269L5.97435 8.06468C6.05433 8.08467 6.13433 8.10067 6.2163 8.11466C6.31505 8.12933 6.4145 8.13868 6.51426 8.14266H6.65422H6.66622L6.7862 8.12867C6.83018 8.12668 6.87618 8.11668 6.92818 8.11668H6.99616L7.13414 8.09669L7.19813 8.08469L7.3141 8.06069H7.33611C7.82729 7.93732 8.27581 7.683 8.63387 7.32482L11.1794 4.77928C12.2728 3.68596 12.2728 1.91332 11.1795 0.819995Z"
                          fill="#DAD9D9"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3619_2090">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>

              <div
                className="rightttside w-100"
                dangerouslySetInnerHTML={{
                  __html: blogData?.content?.rendered,
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default BlogDetail;
